import { intl } from "LocaleWrapper";
import { useStoreState } from "ezStore";
import { Card, Changelog as CCKChangeLog, PageHeader } from "@cofano/cck";
import { ChangelogEntry } from "@cofano/cck/Changelog/Changelog";
import Helmet from "components/helmet/Helmet";
import { Language } from "utils";
import changelog from "../../../../changelog.json";

const Changelog = () => {

	const { user } = useStoreState(store => store.session);
	const isCofanoUser =  user?.email?.includes("@cofano");

	const changes: ChangelogEntry[] = changelog.map(change => {
		if (change["jira-ticket"]) {
			return {
				type: change.type,
				module: change.module,
				description: change.description,
				jiraTicket: change["jira-ticket"],
			};
		} else {
			return change;
		}
	}) as ChangelogEntry[];

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("CHANGELOG")}
					<Helmet title={intl.formatMessage({ id: "CHANGELOG" })} />
				</PageHeader.Title>
			</PageHeader>

			<Card>
				<CCKChangeLog
					entries={changes}
					isCofano={isCofanoUser}
					entryUrl={jiraTicket => {
						if (jiraTicket.startsWith("BOST")) {
							return `https://cofano-external.atlassian.net/browse/${jiraTicket}`;
						} else {
							return `https://cofanosoftware.atlassian.net/browse/${jiraTicket}`;
						}
					}} />
			</Card>
		</div>
	);
};

export default Changelog;
